module.exports = __webpack_public_path__ + "static/media/bus.7f55e5b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/bus.png
// module id = 163
// module chunks = 0